import { useContext, useEffect, useState } from 'react';
import './FullScreen.css';
import { ClosePopupIcon } from '../../../assets/icons/icons';
import Popup from '../../Popup/Popup';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';
import 'swiper/css/zoom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel, Thumbs, FreeMode, Navigation, Zoom } from "swiper";
import ImageWithBackground from '../../ImageWithBackground/ImageWithBackground';
import { ArrowIcon } from '../../../assets/icons/icons';
import { IMG_PLACEHOLDER_PRODUCT } from '../../../assets/utils/constants';
import { parseTitleForParts } from '../../../assets/utils/utils';

function FullScreen({ isOpen, setOpen, product }) {

    useEffect(() => {
        if (!isOpen) { document.body.style.overflow = 'initial'; }
        else { document.body.style.overflow = 'hidden'; }
    });

    function closePopup() {
        setOpen(false);
        setTimeout(() => {
        }, 300);
    }
    const [my_swiper, set_my_swiper] = useState({});
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    return (
        <Popup className="full-popup" popupName={'full-popup'} onClose={closePopup} {...{ setOpen, isOpen }}>

            {/* <button
                className="contact-popup__close-btn"
                type="button"
                onClick={closePopup}
            >
                <svg className='contact-popup__close-icon' xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <path d="M46 18L18.0001 45.9999" stroke="white" stroke-width="2" stroke-linecap="round" />
                    <path d="M46 46L18.0001 18.0001" stroke="white" stroke-width="2" stroke-linecap="round" />
                </svg>
            </button> */}
            <p className='full-popup__product-name'>{product ?
                product.name && product.name.length > 0 ?
                    parseTitleForParts(product.name).title : `` : null}{product ?
                        product.name && product.name.length > 0 && parseTitleForParts(product.name).subtitle ?
                            ` • ` + parseTitleForParts(product.name).subtitle
                            : ``
                        : null}</p>

            <button className="promo-scroll__swiper-arrow-btn promo-scroll__swiper-arrow-btn_left" type="button"
                onClick={() => {
                    if (my_swiper) {
                        my_swiper.slidePrev();
                    }
                }}>
                <ArrowIcon
                    mainClassName={'promo-scroll__swiper-arrow-icon'}
                // fillClassName={'promo-scroll__swiper-arrow-icon-fill'}
                />
            </button>
            {product ?
                <div className={`product-page__photos`}>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        mousewheel={{
                            forceToAxis: true,
                        }}
                        zoom={true}
                        loop={true}
                        modules={[Mousewheel, Thumbs, Navigation, Pagination, Zoom]}
                        thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                        // preventInteractionOnTransition={true}
                        className="photo-slider__cards"
                        onInit={(ev) => {
                            set_my_swiper(ev);
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            1000: {
                                slidesPerView: 'auto',
                                spaceBetween: 0,
                            },
                        }}
                    >
                        {product.files && product.files.length > 0 ?
                            product.files && product.files.length > 1 ?
                                product.files.map((item, i) => (

                                    <SwiperSlide
                                        className="photo-slider__card"
                                        key={`photo-slider__card${i}`}
                                    >
                                        <div className="swiper-zoom-container">
                                            <ImageWithBackground
                                                // onClick={(e) => {
                                                //     // e.target?.requestFullscreen()
                                                //     // setFullScreenSrc(`${MAIN_URL}/get-file/${item?.urls?.orig}`)
                                                //     
                                                // }}

                                                className="photo-slider__card-img"
                                                src={item.urls.orig}
                                                alt=""
                                                metadata={item.metadata}
                                                isVideo={item.metadata.first_frame_db}
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))
                                : product.files.map((item, i) => (
                                    <SwiperSlide
                                        className="photo-slider__card"
                                        key={`photo-slider__card${i}`}
                                    >
                                        <div className="swiper-zoom-container">
                                            <ImageWithBackground
                                                // onClick={(e) => {
                                                //     // e.target?.requestFullscreen()
                                                //     // setFullScreenSrc(`${MAIN_URL}/get-file/${item?.urls?.orig}`)
                                                //     
                                                // }}

                                                className="photo-slider__card-img"
                                                src={item.urls.orig}
                                                alt=""
                                                metadata={item.metadata}
                                                isVideo={item.metadata.first_frame_db}
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))
                            :
                            <SwiperSlide
                                className="photo-slider__card"
                            >
                                <img
                                    // onClick={(e) => {
                                    //     // e.target?.requestFullscreen()
                                    //     setFullScreenSrc(`${MAIN_URL}/get-file/${item.file_path.orig}`)
                                    // }}
                                    className="photo-slider__card-img"
                                    src={IMG_PLACEHOLDER_PRODUCT}
                                    alt=""
                                ></img>
                            </SwiperSlide>
                        }
                    </Swiper>
                    <Swiper
                        onSwiper={setThumbsSwiper}
                        slidesPerView={'auto'}
                        spaceBetween={10}
                        // freeMode={true}
                        watchSlidesProgress={true}
                        modules={[Thumbs]}
                        className="photo-slider__previews photo-slider__cards_vertical"
                    // direction={'vertical'}

                    // centeredSlides={true}
                    >
                        {product.files && product.files.length > 0 ?

                            product.files.map((item, i) => (
                                <SwiperSlide
                                    className={`photo-slider__card-preview photo-slider__card_thumbs`}
                                    key={`photo-slider__card${i}`}
                                >
                                    <ImageWithBackground
                                        // onClick={(e) => {
                                        //     // e.target?.requestFullscreen()
                                        //     setFullScreenSrc(`${MAIN_URL}/get-file/${item.file_path.orig}`)
                                        // }}
                                        className="photo-slider__card-img-preview"
                                        src={item.urls.orig}
                                        alt=""
                                        metadata={item.metadata}
                                        isVideo={item.metadata.first_frame_db}
                                    />
                                </SwiperSlide>
                            ))
                            :
                            <SwiperSlide
                                className="photo-slider__card-preview"
                            >
                                <img
                                    // onClick={(e) => {
                                    //     // e.target?.requestFullscreen()
                                    //     setFullScreenSrc(`${MAIN_URL}/get-file/${item.file_path.orig}`)
                                    // }}
                                    className="photo-slider__card-img"
                                    src={IMG_PLACEHOLDER_PRODUCT}
                                    alt=""
                                ></img>
                            </SwiperSlide>
                        }
                    </Swiper>
                </div>
                : null}
            <button className="promo-scroll__swiper-arrow-btn promo-scroll__swiper-arrow-btn_right" type="button"
                onClick={() => {
                    if (my_swiper) {
                        my_swiper.slideNext();
                    }
                }}>
                <ArrowIcon
                    mainClassName={'promo-scroll__swiper-arrow-icon'}
                // fillClassName={'promo-scroll__swiper-arrow-icon-fill'}
                />
            </button>
        </Popup>
    );
}

export default FullScreen;